import {
  SENSORS_ERROR,
  SENSORS_CONNECT,
  SENSORS_DISCONNECT,
  SENSORS_UPDATE
} from "../../constants/action-types";

import initialState from "../initialState";

const sensors = (state = initialState.sensors, action) => {
  switch (action.type) {
    case SENSORS_CONNECT:
      if (state.sensorsState === 1) {
        return state;
      }
      return { ...state, sensorsState: 1 }

    case SENSORS_DISCONNECT:
      if (state.sensorsState === 4) {
        return state;
      }
      return { ...state, sensorsState: 4 }

    case SENSORS_ERROR:
      if (state.sensorsState === 3) {
        return state;
      }
      return { ...state, sensorsState: 3 }

    case SENSORS_UPDATE:
      return {
        ...state,
        sensorsState: 0,
        sensors: action.payload.map(i=>i)
      }

    default:
      return state;
  }
}

export default sensors;


// WEBPACK FOOTER //
// ./src/store/reducers/sensors.js